import { render, staticRenderFns } from "./TaskShow.vue?vue&type=template&id=071d0b95&"
import script from "./TaskShow.vue?vue&type=script&lang=js&"
export * from "./TaskShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports